module.exports = __webpack_public_path__ + "static/media/Privacy_Policy_French.98bf4f9d.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Privacy_Policy_French.pdf
// module id = 1502
// module chunks = 0